import React, { memo } from 'react';
import { useState, useEffect } from 'react';
import { ListGroup } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSortAmountDown } from '@fortawesome/free-solid-svg-icons';
import FieldListItem from './FieldListItem';
import { Field } from '../types/types';

import { List, AutoSizer } from "react-virtualized";
import FieldFilter from '../features/fields/components/show/FieldFilter';
import { useStore } from '../providers/AppProvider';
import FieldListHeader from '../features/fields/components/show/FieldListHeader';
import { FieldSort } from '../features/fields/components/show/FieldSort';
import { useFieldStore } from '../features/fields/providers/FieldProvider';
import { SETTING_SEASON_YEAR } from '../utils/settings';

type Props = {
    title: string,
    fields: Field[] | undefined,
    fieldsFiltered: any[] | undefined,
    selectedId: number | null,
    onSelectField: Function,
    onHoverField: Function
};

const FIELD_APP_URL = process.env.REACT_APP_FIELD_MGR_ROOT_URL;

const FieldList = ({title, fields, fieldsFiltered, selectedId, onHoverField, onSelectField} : Props) => {
    const { state, settings, updateSettings } = useStore();
    const { isFiltered, isFieldLoading, sortedBy, updateDate } = useFieldStore();

    const [fieldList, setFieldList] = useState<Field[] | null>(null);
    const [totalArea, setTotalArea] = useState<number | null>(null);
    const [selectedFieldId, setSelectedFieldId] = useState<number | null>(null);
    const [scrollToIndex, setScrollToIndex] = useState<number | null>(null);
    const [showFilters, setShowFilters] = useState(false);
    const [showSorts, setShowSorts] = useState(false);

    useEffect(() => {
         console.log("A021324 SETTING_SEASON_YEAR, settings[SETTING_SEASON_YEAR]", SETTING_SEASON_YEAR, settings[SETTING_SEASON_YEAR])
         updateSettings(SETTING_SEASON_YEAR, settings[SETTING_SEASON_YEAR]);
         updateDate(null);
    },[])

    useEffect(() => {
        // make sure the fields have a crop defined.
        let newFields = fields && fieldsFiltered && fieldsFiltered.length <= 0 ? [...fields] : fieldsFiltered ? [...fieldsFiltered] : null;
        console.log("A112923 newFields", newFields);
        console.log("A112923 fieldsFiltered", fieldsFiltered);
        if(newFields) {
            newFields = newFields.filter(item => {
                if (fieldsFiltered && fieldsFiltered.length > 0) {
                    let idToCheck = item.id;
                    let idFound = false;
                    let returnableItem: Field | null = null;
                    for (const fieldFiltered of fieldsFiltered) {
                        if (fieldFiltered.id === idToCheck) {
                            item["farm"] = fieldFiltered.farm;
                            idFound = true;
                            returnableItem = fieldFiltered;
                            break; // No need to continue searching
                        }
                    }
                    //console.log("B112923 idFound, returnableItem",idFound, returnableItem);
                    if (idFound && returnableItem){
                        returnableItem.crop = state.crops.find(c => c.id === returnableItem?.crop_id);
                        return returnableItem; 
                    }
                }else{
                    if (fieldsFiltered?.length !== 0) {
                        item.crop = state.crops.find(c => c.id === item.crop_id);
                        return item;
                    }
                }
            });
        }
        console.log("B112923 newFields", newFields);
        setFieldList(newFields);
    }, [fields, fieldsFiltered]);

    useEffect(() => {
        console.log("072825 fieldList", fieldList);
        if (fieldList) {
            const _totalArea = fieldList.reduce((sum, field) => sum + (field.area ?? 0), 0);
            console.log("072825 Total Area:", _totalArea);
            setTotalArea(_totalArea);
        }
    }, [fieldList]);

    useEffect(() => {
        setSelectedFieldId(selectedId);

        const index = fieldList?.findIndex((f: Field) => f.id === selectedId);

        if(index && index !== -1) {
            setScrollToIndex(index);
        }
   
    }, [selectedId]);

    const onFieldClick = (field: Field) => {
        onSelectField(field);
    }

    const onMouseEnter = (field: Field) => {
        onHoverField(field);
    }

    const onMouseLeave = (field: Field) => {
        onHoverField(null);
    }

    const renderRow = ({ index, key, style }: any) => {
        const field = fieldList![index];
        console.log("A070324 B field", field);
        return (
            <ListGroup.Item style={style} key={field.id} className="ls-list-group px-3 rounded-0" action variant="light" active={selectedFieldId && selectedFieldId == field.id ? true : false }
                onMouseEnter={() => onMouseEnter(field)} 
                onMouseLeave={() => onMouseLeave(field)} 
                onClick={() => onFieldClick(field)}>
                <FieldListItem item={field} sort={sortedBy}/>
            </ListGroup.Item>
        );
    }

    return (
        <div className="field-list d-flex flex-column h-100">
            <div className="align-items-start d-flex justify-content-between px-2 py-3">
                <h3 className="m-0 ml-2 text-lg font-weight-bold">{title}</h3>
                <div className="d-flex">
                    <div
                        onClick={(e: any) => {
                        setShowFilters(prevState => {
                            return !prevState;
                        });
                        }}
                        className="d-flex align-items-center mr-3"
                        style={{cursor: 'pointer'}}
                        title={`${isFiltered ? 'Blocks are filtered' : 'No filter applied'}`}>
                        <FontAwesomeIcon className={`text-sm ${isFiltered ? 'text-info' : ''}`} icon="filter" />
                    </div>
                    <div
                        onClick={(e: any) => {
                        setShowSorts(prevState => {
                            return !prevState;
                        });
                        }}
                        className="d-flex align-items-center"
                        style={{cursor: 'pointer'}}
                        title="Sort blocks">
                        <FontAwesomeIcon className="text-sm" icon={faSortAmountDown} />
                    </div>
                </div>
            </div> 

            { showFilters && <FieldFilter onCancel={() => setShowFilters(false)} /> }

            { showSorts && <FieldSort onCancel={() => {
                setShowSorts(false);
                setScrollToIndex(0);
            }} /> }

            <FieldListHeader totalArea={totalArea} fieldCount={fieldList ? fieldList.length : 0} isFiltered={isFiltered} />
           
            <div className="flex-grow-1 p-0">
                <AutoSizer>
                    {({height, width}: any) => (
                    <ListGroup>
                        <List
                            width={width}
                            height={height}
                            rowHeight={70}
                            rowRenderer={renderRow}
                            rowCount={fieldList ? fieldList.length : 0}
                            scrollToIndex={scrollToIndex ?? 0}
                            overscanRowCount={3} />
                    </ListGroup>)}
                </AutoSizer>
            </div>      
        </div>
    );
}

export default memo(FieldList);
